export default __webpack_public_path__ + "static/media/habits_icon.089863d8.svg";